// React Imports
import * as React from 'react';
import {useEffect, useState} from "react";
import {useForm} from "react-hook-form";
import {useDispatch, useSelector} from "react-redux";

// Mui Imports
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
import {Checkbox, FormHelperText, Input, InputLabel, Select} from "@mui/material";

// App Imports
import {
    cloneSectionContents,

    getContractCS, graftSection
} from "./ContractSectionClient";
import {changeCrudSnackbar} from "../CommonComponents/crudSnackbarSlice";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import {getContractsByType, getSomeContracts} from "../Contract/ContractClient";
import Stack from "@mui/material/Stack";
import {changeContractSection} from "./contractSectionSlice";
import {getAllDataPointValues} from "../DataPointValue/DataPointValueClient";
import {changeContract} from "../Contract/contractSlice";


// Main Function
export default function ContractSectionCloningForm({fetchContractSections}) {


    // ****************** BEGIN STATES ****************************

    const [submitting, setSubmitting] = useState(false);
    const [showCategoryMenu, setShowCategoryMenu] = React.useState(false);
    const [showContractMenu, setShowContractMenu] = React.useState(false);
    const [showDestinationMenu, setShowDestinationMenu] = React.useState(false);
    const [showPreviousMenu, setShowPreviousMenu] = React.useState(false);

    const [allDpv, setAllDpv] = useState([]);
    const [contractTypeDropdown, setContractTypeDropdown] = useState([]);
    const [participationContractDropdown, setParticipationContractDropdown] = useState([]);
    const [royaltyContractDropdown, setRoyaltyContractDropdown] = useState([]);
    const [residualContractDropdown, setResidualContractDropdown] = useState([]);
    const [configurationDropdown, setConfigurationDropdown] = useState([]);

    const [contractCategoryDropdown, setContractCategoryDropdown] = useState([]);
    const [contractCategory, setContractCategory] = useState([]);

    const selectedCdpDp = useSelector((state) => state.contractSectionSlc.value.dataPointId);
    // const selectorContractId = useSelector((state) => state.contractSectionSlc.value.contractSectionId);
    const selectorContractName = useSelector((state) => state.contractSectionSlc.value.contractName);
    const selectorSectionId = useSelector((state) => state.contractSectionSlc.value.contractSectionId);
    const selectorSectionName = useSelector((state) => state.contractSectionSlc.value.sectionName);

    const mousedContractSectionId = useSelector((state) => state.contractDrilldownSlcCS.value.mousedId);

    const [contractDropdown, setContractDropdown] = useState([]);
    const [selectedContract, setSelectedContract] = useState(0);
    let contractFilter;

    // ****************** END STATES ****************************


    // ****************** BEGIN STORE ****************************

    const dispatchData = useDispatch() ;
    const selectorContractSectionId = useSelector((state) => state.contractSectionSlc.value.id);
    const selectorCsCloningDrawerState = useSelector((state) => state.contractSectionSlc.value.csCloningDrawerState);
    const selectorContractAPI = useSelector((state) => state.contractSlc.value.contractGridAPI);


    const selectorContractGridAPI = useSelector((state) => state.contractSlc.value.contractGridAPI);
    // const selectorDestinationId = useSelector((state) => state.contractDrilldownSlcCS.value.mousedDestinationSectionId);

    // const selectorPreviousId = useSelector((state) => state.contractDrilldownSlcCS.value.mousedPreviousSectionId);
    const selectorContractId = useSelector((state) => state.contractSlc.value.id);
    const [destinationDropdown, setDestinationDropdown] = useState([]);

    // const [selectedDestination, setSelectedDestination] = useState(useSelector((state) => state.contractDrilldownSlcCS.value.mousedDestinationSectionId));
    const [selectedDestination, setSelectedDestination] = useState(null);
    // const comboDestination = selectorDestinationId !== undefined > 0 ? selectorDestinationId : selectedDestination;

    const [previousDropdown, setPreviousDropdown] = useState([]);
    // const [selectedPrevious, setSelectedPrevious] = useState(useSelector((state) => state.contractDrilldownSlcCS.value.mousedPreviousSectionId));
    const [selectedPrevious, setSelectedPrevious] = useState(null);
    const [selectedOrigin, setSelectedOrigin] = useState(null);

    const selectorCsDrawerMode = useSelector((state) => state.contractSectionSlc.value.csDrawerMode);




    // ****************** END STORE ****************************


    // ****************** BEGIN REGISTER ****************************

    const {register, handleSubmit} = useForm(
        // {
        //     defaultValues: {
        //         include_filters: true
        //     }
        // }
    );

    // ****************** END REGISTER ****************************

    const fetchDataPointValuesForDropdowns = React.useCallback (() => {
        console.log("fetchDataPointValuesForDropdowns triggered");
        getAllDataPointValues()

            .then(data => {
                console.log("This is the data point values for the dropdowns");
                setAllDpv(data);
                console.log(data);
                // setItems(data.sort((a, b) => a.name > b.name ? 1 : -1) );
                setContractTypeDropdown(data.filter(data => data.dataPointId === 89 || (data.dataPointId === 90 && data.id === 802) ));
                setParticipationContractDropdown(data.filter(data => data.dataPointId === 2127));
                setRoyaltyContractDropdown(data.filter(data => data.dataPointId === 2128));
                setResidualContractDropdown(data.filter(data => data.dataPointId === 2126));
                setConfigurationDropdown(data.filter(data => data.dataPointId === 2197));
                setContractCategoryDropdown(data.filter(data => data.dataPointId === 2127));
            })
    },[]);

    useEffect(() => {
        fetchDataPointValuesForDropdowns()
    },[fetchDataPointValuesForDropdowns])





    const fetchDestinationContracts = () =>
        // getSomeContracts(selectorContractAPI)
        getContractsByType(contractCategory)
            .then(data => {
                console.log(data);

                setContractDropdown(data);

            })
    useEffect(() => {
        console.log("This is triggering the fetch for the contract dropdown...");
        fetchDestinationContracts();
    }, [contractCategory]);


    const handleContractTypeChange = (contractTypeEvent) => {
        console.log("This is the selected Contract Category after change");
        setContractCategoryDropdown(
            contractTypeEvent.target.value === 45 ? residualContractDropdown :
                contractTypeEvent.target.value === 46 ? participationContractDropdown :
                    contractTypeEvent.target.value === 47 ? royaltyContractDropdown :
                        contractTypeEvent.target.value === 802 ? configurationDropdown :
                            []
        );

        setContractCategory(null);
        setSelectedDestination(null);
        setSelectedPrevious(null);
        console.log("This is for the selected Contract Type");
        console.log(contractTypeEvent.target.value);
        setSelectedContract(null);
        contractFilter = null;
        setShowCategoryMenu (true);
        setShowContractMenu (false);
        setShowDestinationMenu (false);
        setShowPreviousMenu (false);
        // dispatchData(changeContract({id: contractCategoryEvent.target.value, name: contractCategoryEvent.target.value}))
        // fetchDestinationContracts()
    };


    const handleContractCategoryChange = (contractCategoryEvent) => {
        console.log("This is the selected Contract Category after change");
        contractFilter = contractCategoryEvent.target.value;
        setContractCategory(
            contractCategoryEvent.target.value === 3214 ? 'PartsAbstracts' :
                contractCategoryEvent.target.value === 3771 ? 'Branches' :
                    contractCategoryEvent.target.value === 1234 ? 'PartsDocuments' :
                        contractCategoryEvent.target.value === 1232 ? 'PartsStandards' :
                            contractCategoryEvent.target.value === 3235 ? 'PartsPackages' :
                                contractCategoryEvent.target.value === 1233 ? 'PartsRiders' :
                                    contractCategoryEvent.target.value === 1224 ? 'CBA' :
                                        contractCategoryEvent.target.value === 1225 ? 'Sideletter' :
                                            contractCategoryEvent.target.value === 2119 ? 'SideletterTemplate' :
                                                contractCategoryEvent.target.value === 6565 ? 'DeterminationLetter' :
                                                    contractCategoryEvent.target.value === 2937 ? 'RoyalStandards' :
                                                        contractCategoryEvent.target.value === 3336 ? 'RoyalAbstracts' :
                                                            contractCategoryEvent.target.value === 2939 ? 'RoyalBands' :
                                                                contractCategoryEvent.target.value === 2940 ? 'RoyalLicenses' :
                                                                    contractCategoryEvent.target.value === 1270 ? 'PartsPre' :
                                                                        contractCategoryEvent.target.value === 1271 ? 'PartsPost' :
                                                                            contractCategoryEvent.target.value === 1276 ? 'PartsSystem' :
                                                                                contractCategoryEvent.target.value
        );
        setSelectedDestination(null);
        setSelectedPrevious(null);
        console.log("This is for the selected Contract Category");
        console.log(contractCategoryEvent.target.value);
        setSelectedContract(null);
        contractFilter = null;
        setShowContractMenu (true);
        setShowDestinationMenu (false);
        setShowPreviousMenu (false);
        // dispatchData(changeContract({id: contractCategoryEvent.target.value, name: contractCategoryEvent.target.value}))
        // fetchDestinationContracts()
    };

    const handleContractChange = (contractEvent) => {
        contractFilter = contractEvent.target.value;
        setSelectedContract(contractEvent.target.value);
        setSelectedDestination(null);
        setSelectedPrevious(null);
        setShowDestinationMenu (true);
        setShowPreviousMenu (false);
        console.log("This is for the selected Contract Section");
        console.log(contractEvent.target.value)
        // dispatchData(changeContract({id: contractEvent.target.value, name: contractEvent.target.value}))
        // fetchContractSectionsForDestination()
    };


    let destinationFilter = null;

    const fetchContractSectionsForDestination = () =>
        getContractCS(selectedContract)

            .then(data => {
                console.log(data);
                console.log("showDestinationMenu = ", showDestinationMenu);
                // setItems(data.sort((a, b) => a.name > b.name ? 1 : -1) );

                setDestinationDropdown(data);
                // setShowDestinationMenu (true);
            })
    useEffect(() => {
        console.log("This is triggering the fetch for the destination section dropdown...");
        fetchContractSectionsForDestination();
    }, [selectedContract]);


    const handleDestinationChange = (destinationEvent) => {
        destinationFilter = destinationEvent.target.value;
        setSelectedDestination(destinationEvent.target.value);
        console.log("This is the selected Destination Section after change");
        console.log(destinationEvent.target.value);
        console.log(selectedDestination);
        //
        //
        // fetchContractSectionsForPrevious()
        //     .then(() => {
        //         console.log("selectedDestination")
        //         // dispatchData(changeContractSection({csDrawerState: false, csGridRefresh: true}))
        //     })
        setShowPreviousMenu (true);
    };



    // const fetchContractSectionsForPrevious = () =>
    //
    //     getContractCS(selectorContractId)
    //
    //         .then(data => {
    //             console.log(data);
    //
    //             if(destinationFilter !== null && destinationFilter !== ""){
    //                 setPreviousDropdown(data.filter(data => data.destinationSectionId ===  destinationFilter));
    //                 console.log("We're filtering for records with the same destination");
    //                 console.log("selectedDestination = ", selectedDestination);
    //                 console.log("selectorDestinationId = ", selectorDestinationId);
    //                 console.log("selectedPrevious = ", selectedPrevious);}
    //             else
    //             {setPreviousDropdown(data.filter(data => data.recordLevel ===  1));}
    //
    //         })
    //         .then(() => console.log("selectedDestination"))
    //         .then(() => console.log({selectedDestination}))
    // // .then(() => {setShowPreviousMenu(false)}).then(() => {setShowPreviousMenu(true)})
    // // .then(() => {setShowPreviousMenu(false)}).then(() => {setShowPreviousMenu(true)})
    //
    // useEffect(() => {
    //     console.log("This is for the dropdown2...");
    //     fetchContractSectionsForPrevious()
    //         .then(() => {
    //             console.log("selectedDestination")
    //             // dispatchData(changeContractSection({csDrawerState: false, csGridRefresh: true}))
    //         })
    // }, []);

    //
    // const handlePreviousChange = (previousEvent) => {
    //     setSelectedPrevious(previousEvent.target.value);
    //     console.log("This is the selected Previous Section after change");
    //     console.log(previousEvent.target.value);
    // };




    // ****************** BEGIN CRUD ****************************

    // function onSubmit(data) {
    //     console.log("here's my contractSection data before I submit it ")
    //     console.log({data})
    // }

    function onSubmit(data) {
        setSubmitting(true)
        let source_section_id = parseInt(data.source_section_id)
        let destination_section_id = parseInt(data.destination_section_id)
        let minimum_cdp = parseInt(data.minimum_cdp)
        let maximum_cdp = parseInt(data.maximum_cdp)
        let include_filters = data.include_filters
        console.log("here's my contractSection data before I submit it ")
        console.log({data})
        console.log("Cloning data Submitted before");
        console.log(source_section_id,destination_section_id,
            minimum_cdp, maximum_cdp)
        console.log("here's my parsed data minus contract and section")
        cloneSectionContents(source_section_id, destination_section_id, minimum_cdp, maximum_cdp, include_filters)
            .then(() => {
                console.log("Cloning data Submitted After");
                console.log(source_section_id,destination_section_id,
                    minimum_cdp, maximum_cdp)
            })
            .catch(err => {
                console.log(err)
            })                .then(() => {
        })
            .then(() =>{
                setSubmitting(false);
                dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Records cloned"}));
                dispatchData(changeContractSection({csCloningDrawerState: false, csGridRefresh: true}))})


    };

    // ****************** END CRUD ****************************





    // ****************** BEGIN MISC ****************************

    const onFinishFailed = errorInfo => {
        alert(JSON.stringify(errorInfo, null, 2));
    };


    function closeContractSectionDrawer() {
        dispatchData(changeContractSection({
            csCloningDrawerState: false}));



    };

    // ****************** END MISC ****************************

    // *********************** BEGIN DROPDOWNS **************************

    const [sectionDropdown, setSectionDropdown] = useState([]);




// *********************** END DROPDOWNS **************************



    // ****************** BEGIN FORM ****************************

    function contractSectionForm(){

        // const {register, handleSubmit} = useForm(
        //     {
        //         defaultValues: {
        //             include_filters: true
        //         }
        //     }
        // );

        return(
            <form
                onSubmit={handleSubmit((data)=>        onSubmit(data))}
            >
                <Box
                    sx={{width: 800, height: 300, pl: 5}}
                    role="presentation"
                >
                    <h1 style={{cursor: 'pointer'}}
                        onClick={() => closeContractSectionDrawer()}
                    >Section Contents Cloning Form</h1>

                    <h4>Source Section:</h4>
                    <h4>{useSelector((state) => state.contractDrilldownSlcCS.value.mousedName)}</h4>
                    <br/>
                    <FormControl variant="standard" sx={{m: 1, minWidth: 300}}>
                        <InputLabel htmlFor="contractList.id">Contract Type</InputLabel>
                        <Select
                            onChange={handleContractTypeChange}
                        >
                            {contractTypeDropdown.map((contractTypeItem) =>
                                <MenuItem value={contractTypeItem.id}>{contractTypeItem.name}</MenuItem>
                            )}
                        </Select>
                        <FormHelperText id="value_helper">choose the contract Type</FormHelperText>
                    </FormControl>
                    <br/>
                    {showCategoryMenu && <FormControl variant="standard" sx={{m: 1, minWidth: 300}}>
                        <InputLabel htmlFor="contractList.id">Contract Category</InputLabel>
                        <Select
                            onChange={handleContractCategoryChange}
                        >
                            {contractCategoryDropdown.map((contractCategoryItem) =>
                                <MenuItem value={contractCategoryItem.id}>{contractCategoryItem.name}</MenuItem>
                            )}
                        </Select>
                        <FormHelperText id="value_helper">choose the contract category</FormHelperText>
                    </FormControl>}


                    <br/>
                    {showContractMenu &&
                        <FormControl variant="standard" sx={{m: 1, minWidth: 300}}>
                            <InputLabel htmlFor="destinationContract.id">Destination Contract</InputLabel>
                            <Select
                                onChange={handleContractChange}
                            >
                                {contractDropdown.map((contractItem) =>
                                    <MenuItem value={contractItem.id}>{contractItem.name}</MenuItem>
                                )}
                            </Select>
                            <FormHelperText id="value_helper">choose the destination contract</FormHelperText>
                        </FormControl>}
                    <br/>
                    {/*<br/>*/}


                    {/*<br/>*/}
                    {/*<br/>*/}
                    {/*<br/>*/}
                    {showDestinationMenu &&
                        <div>
                            {/*<p>Hello!</p>*/}
                        <FormControl variant="standard" sx={{ m: 1, minWidth: 300 }}
                                     // style={{ visibility: selectorCsDrawerMode === "Edit" ? "hidden" : "visible"}}
                        >
                            <InputLabel htmlFor="destinationSectionId">Destination Section</InputLabel>
                            <Select
                                {...register('destination_section_id', { required: true })}
                                labelId="demo-simple-select-filled-destination"
                                id="destination_section_id"

                                value= {selectedDestination}
                                // value= {selectorDestinationId === undefined || selectorDestinationId === null ? selectedDestination : selectorDestinationId}
                                label="Destination Section"
                                onChange={handleDestinationChange}
                            >
                                {destinationDropdown.map((destinationItem) =>
                                    <MenuItem
                                        value={destinationItem.id}
                                        sx={{
                                            fontWeight: destinationItem.recordLevel === 1 ? 'bold' : 'normal',
                                            pl: destinationItem.recordLevel * 2 }}
                                    >{destinationItem.name}</MenuItem>
                                )

                                }
                            </Select>
                            <FormHelperText id="value_helper">select the contract section to update</FormHelperText>
                        </FormControl>
                </div>
                }
                    {/*<br/>*/}
                    <br/>
                    <br/>
                    {/*<br/>*/}
                    {/*{showPreviousMenu &&*/}
                    {/*    <FormControl variant="standard" sx={{ m: 1, minWidth: 300 }}*/}
                    {/*                 style={{ visibility: selectorCsDrawerMode === "Edit" ? "hidden" : "visible"}}>*/}
                    {/*        <InputLabel  htmlFor="previousSectionId">Previous Section</InputLabel>*/}
                    {/*        <Select*/}
                    {/*            {...register('previousSectionId', { required: false })}*/}
                    {/*            labelId="demo-simple-select-filled-label2"*/}
                    {/*            id="previousSectionId"*/}
                    {/*            label="Previous Section"*/}
                    {/*            // value= {selectorPreviousId === undefined || selectorPreviousId === null  ? selectedPrevious : selectorPreviousId}*/}
                    {/*            value=        {selectedPrevious}*/}
                    {/*            onChange={handlePreviousChange}*/}
                    {/*            // defaultValue=        {selectedPrevious}*/}
                    {/*        >*/}
                    {/*            {previousDropdown.map((previousItem) =>*/}
                    {/*                <MenuItem value={previousItem.id}>{previousItem.name} - {previousItem.ordinalNumber}</MenuItem>*/}
                    {/*            )}*/}
                    {/*        </Select>*/}
                    {/*        <FormHelperText id="origin_helper">select the section this will go after within the destination</FormHelperText>*/}
                    {/*    </FormControl>}*/}
                    {/*{showPreviousMenu &&<br/>}*/}
                    {showPreviousMenu &&
                        <div>
                    <InputLabel htmlFor="filtersInd">Include Section Filters</InputLabel>
                    <Checkbox
                        // checked={true}
                        // defaultValue={true}
                        sx={{width: 120}}
                        defaultChecked
                        {...register('include_filters')}
                    />
                    <br/>
                    <br/>
                    <br/>
                    {/*<br/>*/}
                    <Stack direction="row" spacing={2}>
                        <Box>
                            <InputLabel htmlFor="minimum_cdp">Minimum Data Point</InputLabel>
                            <Input sx={{m: 1, minWidth: 60}}
                                   {...register('minimum_cdp', {required: false})}
                                   type="number"
                                   id="minimum_cdp" name="minimum_cdp" label="Mcode"
                                   aria-describedby="minimum_cdp_entry"
                            />
                            <FormHelperText id="minimum_cdp_helper">optional</FormHelperText>
                        </Box>
                        <Box>
                            <InputLabel htmlFor="maximum_cdp">Maximum Data Point</InputLabel>
                            <Input sx={{m: 1, minWidth: 60}}
                                   {...register('maximum_cdp', {required: false})}
                                   type="number" id="maximum_cdp" name="maximum_cdp" label="maximum_cdp"
                                   aria-describedby="maximum_cdp_entry"
                            />
                            <FormHelperText id="maximum_cdp_helper">optional</FormHelperText>
                        </Box>
                    </Stack>
                        </div>
                }
                    <Input style={{visibility: "hidden"}}
                           {...register('source_section_id', {required: false})}
                           type="number" id="source_section_id" name="source_section_id" label="source_section_id"
                           aria-describedby="status_entry"
                           defaultValue={useSelector((state) => state.contractDrilldownSlcCS.value.mousedId)}
                    />
                    <br/>
                    <br/>
                    <Button
                        type="submit"
                    >Submit</Button>
                    <Button onClick={() => closeContractSectionDrawer()}>Cancel</Button>
                </Box>
            </form>
        );
    }

    // ****************** END FORM ****************************


    // ****************** BEGIN RETURN ****************************

    return (
        <div>
            <Drawer
                anchor='right'
                open={selectorCsCloningDrawerState}
                initialState={{open: false}}
                onClose={closeContractSectionDrawer}
            >
                {contractSectionForm()}
            </Drawer>
        </div>
    );

    // ****************** END RETURN ****************************

}
